import { useEffect, useState } from "react";

export default function Projects() {
  const [media, setMedia] = useState([]);

  useEffect(() => {
    // Example: Fetch media from Firebase or your backend
    // For now, use sample local data
    setMedia([
      { id: 1, type: "image", url: "/demo1.jpg" },
      { id: 2, type: "video", url: "/demo2.mp4" },
    ]);
  }, []);

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">My Projects</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {media.map((item) => (
          <div key={item.id} className="bg-white shadow rounded p-2">
            {item.type === "image" ? (
              <img src={item.url} alt="Project" className="w-full rounded" />
            ) : (
              <video controls className="w-full rounded">
                <source src={item.url} type="video/mp4" />
              </video>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
